import React, { useState } from "react";
import { Button, Drawer, Form, Input, message } from "antd";
import axiosConfig from "../../../util/axiosConfig";
import requestErrorHandler from "../../../util/requestErrorHandler";

const AddTruckProfile = ({ getCategory, category }: any) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  async function handleSubmit() {
    setIsLoading(true);
    await axiosConfig
      .post("/truck-category/create-profile", {
        ...form.getFieldsValue(),
        truckCategoryId: category.id,
      })
      .then((response: any) => {
        message.success("Category added successfully");
        form.resetFields();
        setOpen(false);
        getCategory();
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      <Button
        type="primary"
        className="bg-[#096DD9]"
        onClick={() => setOpen(true)}
      >
        Add Truck Category Profile
      </Button>
      <Drawer
        title="Add Truck Category Category"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Form
          className="w-100"
          onFinish={handleSubmit}
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: "Enter a valid type" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="tonnage"
            label="Tonnage"
            rules={[{ required: true, message: "Enter a valid tonnage" }]}
          >
            <Input />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={isLoading}
            className="bg-[#096DD9]"
          >
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default AddTruckProfile;
